
export * from "./program-project-mismatch-message";


import { ProgramProjectMismatchMessageComponent } from './program-project-mismatch-message';




export const ProgramMessages = [
    ProgramProjectMismatchMessageComponent,
];